$(function() {

	/*
		$("#sort-title").click(function(){

			$("#sort-pupop").toggleClass("open");
			$(".overall-dark").toggleClass("open");

		});

		*/


	$(document.body).click(function() {
		$("#sort-pupop.open").removeClass("open");
		$(".overall-dark.open").removeClass("open");
	});


	$(".c-filter").on("click", "#sort-title", function(e) {
		$(this).next().toggleClass("open");
		$(".overall-dark").toggleClass("open");
		e.stopPropagation();
	});


	$(document.body).keyup(function(e) {
		if (e.key === 'Escape') {
			$(".overall-dark.open").removeClass("open");
			$("#sort-pupop").removeClass("open");
		}
	});

});
